import { gql } from 'glimmer-apollo';

// Optimized query for news list page - excludes body content and optimizes images
export const NEWS_INDEX_OPTIMIZED_QUERY = gql`
  fragment AuthorInfo on Author {
    displayName
    profilePicture {
      url(
        transform: {
          width: 48
          height: 48
          resizeStrategy: THUMB
          format: WEBP
        }
      )
    }
  }

  fragment CoverImageInfo on Asset {
    url(
      transform: { width: 300, height: 180, resizeStrategy: FILL, format: WEBP }
    )
  }

  query NewsIndex($limit: Int = 10, $skip: Int = 0) {
    articles: gameArticleCollection(
      limit: $limit
      skip: $skip
      order: [publishedDate_DESC]
    ) {
      total
      items {
        title
        slug
        shortDescription
        publishedDate
        coverImage {
          ...CoverImageInfo
        }
        author {
          ...AuthorInfo
        }
      }
    }
  }
`;

// For pagination and infinite scroll
export const NEWS_INDEX_PAGINATED_QUERY = gql`
  fragment AuthorInfo on Author {
    displayName
    profilePicture {
      url(
        transform: {
          width: 48
          height: 48
          resizeStrategy: THUMB
          format: WEBP
        }
      )
    }
  }

  fragment CoverImageInfo on Asset {
    url(
      transform: { width: 300, height: 180, resizeStrategy: FILL, format: WEBP }
    )
  }

  query NewsIndexPaginated($limit: Int!, $skip: Int!) {
    articles: gameArticleCollection(
      limit: $limit
      skip: $skip
      order: [publishedDate_DESC]
    ) {
      total
      items {
        title
        slug
        shortDescription
        publishedDate
        coverImage {
          ...CoverImageInfo
        }
        author {
          ...AuthorInfo
        }
      }
    }
  }
`;
